(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

   /*
  RR-CUSTOM | DWELL-3.2.1 | COLLECTION | SECTION 1+2 | COUNT + VARIANT CARD PRICING (VARIATOR) | 2026-02-05

  Section 1: Count visible variant cards (matches what Variator renders)
  Section 2: Update each card price to match the variant shown on that card

  Safety:
  - Do NOT observe document.body (can cause loops/freezes)
  - Observe only results-list / collection wrapper / ResultsList
  - Debounce updates with requestAnimationFrame
  */

  /* ===== Section 1: Count ===== */
  function rrFindCountEl() {
    return (
      document.querySelector('.facets__product-count') ||
      document.querySelector('.products-count-wrapper span') ||
      document.querySelector('[data-filters] .product-count')
    );
  }

  function rrCountVisibleCards() {
    const cards = Array.from(document.querySelectorAll('.product-grid__item')).filter(
      (el) => el && el.offsetParent !== null
    );
    return cards.length;
  }

  let rrScheduled = false;
  let rrLastCount = null;

  function rrUpdateCount() {
    const el = rrFindCountEl();
    if (!el) return;

    const n = rrCountVisibleCards();
    if (rrLastCount === n) return;
    rrLastCount = n;

    const label = n === 1 ? 'item' : 'items';
    const original = el.textContent || '';
    const wantsUpper = /[A-Z]/.test(original);

    const text = `${n} ${label}`;
    el.textContent = wantsUpper ? text.toUpperCase() : text.toLowerCase();
  }

  /* ===== Section 2: Variant card pricing ===== */
  const rrProductJsonCache = Object.create(null);

  function rrFormatMoney(cents) {
  const value = Number(cents || 0) / 100;
  return `$${value.toFixed(2)}`;
}

  function rrGetHandleFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      const m = u.pathname.match(/\/products\/([^\/\?\#]+)/);
      return m ? m[1] : null;
    } catch (e) {
      return null;
    }
  }

  function rrGetVariantIdFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (link) {
      try {
        const v = new URL(link.getAttribute('href'), location.origin).searchParams.get('variant');
        if (v) return String(v);
      } catch (e) {}
    }

    const hidden = card.querySelector('input[name="id"]');
    if (hidden && hidden.value) return String(hidden.value);

    return null;
  }

  function rrGetProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (rrProductJsonCache[handle]) return Promise.resolve(rrProductJsonCache[handle]);

    return fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        rrProductJsonCache[handle] = json;
        return json;
      })
      .catch(() => null);
  }

  function rrUpdateCardPrices() {
    const cards = Array.from(document.querySelectorAll('.product-grid__item')).filter(
      (el) => el && el.offsetParent !== null
    );
    if (!cards.length) return;

    const byHandle = new Map();

    cards.forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const handle = rrGetHandleFromHref(link.getAttribute('href'));
      if (!handle) return;

      if (!byHandle.has(handle)) byHandle.set(handle, []);
      byHandle.get(handle).push(card);
    });

    byHandle.forEach((cardList, handle) => {
      rrGetProductJson(handle).then((json) => {
        if (!json || !json.variants || !json.variants.length) return;

        cardList.forEach((card) => {
          const vid = rrGetVariantIdFromCard(card);
          let variant = null;

          if (vid) {
            variant = json.variants.find((v) => String(v.id) === String(vid));
          }
          if (!variant) variant = json.variants[0];

          const priceText = rrFormatMoney(variant.price);

          // Dwell 3.2.1: update only product-price span.price within this card
          const priceNodes = card.querySelectorAll('product-price span.price');
          priceNodes.forEach((node) => {
            if (node.textContent !== priceText) node.textContent = priceText;
          });

          // Keep Quick Add aligned (if present)
          const idInput = card.querySelector('input[name="id"]');
          if (idInput && idInput.value !== String(variant.id)) {
            idInput.value = String(variant.id);
          }
        });
      });
    });
  }

  /* ===== Shared scheduler + observers ===== */
  function rrScheduleUpdate() {
    if (rrScheduled) return;
    rrScheduled = true;
    requestAnimationFrame(() => {
      rrScheduled = false;
      rrUpdateCount();
      rrUpdateCardPrices();
    });
  }

  function rrGetGridRoot() {
    const resultsList = document.querySelector('results-list');
    if (resultsList) return resultsList;

    const wrapper = document.querySelector('.collection-wrapper');
    if (wrapper) return wrapper;

    const results = document.getElementById('ResultsList');
    if (results) return results;

    return null;
  }

  function rrBindCollectionUpdates() {
    rrScheduleUpdate();

    document.addEventListener('shopify:section:load', rrScheduleUpdate, { passive: true });
    document.addEventListener('shopify:facets:updated', rrScheduleUpdate, { passive: true });

    const root = rrGetGridRoot();
    if (!root || !('MutationObserver' in window)) return;

    const obs = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        if (
          mutations[i].type === 'childList' &&
          (mutations[i].addedNodes.length || mutations[i].removedNodes.length)
        ) {
          rrScheduleUpdate();
          break;
        }
      }
    });

    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rrBindCollectionUpdates, { once: true });
  } else {
    rrBindCollectionUpdates();
  }

  } catch(e) { console.error(e); }
})();
})();
